<style lang="scss" scoped>
.home {
  padding: 0;
  margin-top: -10px;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}




.ys_icon{
  font-size:30px;
  color:#dfdfdf;
}
</style>

<template>
  <div class="home">
    
    <!-- <l-auth auth="c_home_show">
      <l-c-home></l-c-home>
    </l-auth>

    <l-auth auth="mt_home_show">
      <l-mt-home ></l-mt-home>
    </l-auth> -->
    <div class="mg_10">
      <h1>数据统计</h1>
    </div>
    <el-row>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_primary flex justify-between items-center">
          <div>
            <p class="title">新增场所</p>
            <p>{{place_new_count}}</p>
          </div>
          <i class="el-icon-circle-plus ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_success flex justify-between items-center">
          <div>
            <p class="title">总场所数</p>
            <p>{{place_count}}</p>
          </div>
          <i class="el-icon-success ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_error flex justify-between items-center">
          <div>
            <p class="title">新增隐患</p>
            <p>{{hidden_new_count}}</p>
          </div>
          <i class="el-icon-warning ys_icon"></i>
          </div>
        </div>
      </el-col>
      
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_info flex justify-between items-center">
          <div>
            <p class="title">总隐患数</p>
            <p>{{hidden_count}}</p>
          </div>
          <i class="el-icon-remove ys_icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>
      <el-row>
        <el-col :span="16">
          <div class="mg_10">  
          <div class="ys_chart">
            <div class="ys_chart_title">
              <span>
              数量统计</span>
            </div>
            <div class="ys_chart_box">
              <linechart :list="list"/>
            </div>
          </div>
          </div>
        </el-col>
        
        <el-col :span="8">
          <div class="mg_10">  
          <div class="ys_chart">
            <div class="ys_chart_box">
              <timechart/>
            </div>
          </div>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
// import CHome from "./CHome";
// import MtHome from "./MtHome";
import linechart from "@/components/chart/linechart";
 import timechart from "@/components/chart/timechart";
export default {
  name: "home",
  components: {
    // [CHome.name]: CHome,
    // [MtHome.name]: MtHome,
    linechart,
    timechart
  },

  data() {
    return {
      loading: false,
      place_count:0,
      place_new_count:0,
      hidden_count:0,
      hidden_new_count:0,
      list:[]
    };
  },

  mounted() {
    //   this.companyChart();
    //   this.taskCharg();
    //   this.userRoleChart();
    this.getList();
  },
  methods:{
    getList(){
      this.$_invoke(`home_getData`).then((res) => {
        res=res.data
        this.place_count=res.place_count
        this.place_new_count=res.place_new_count
        this.hidden_count=res.hidden_count
        this.hidden_new_count=res.hidden_new_count
        this.list=res.type_data
      });
    }
  }
};
</script>
